import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import { genericRequiredFieldError } from '../../constants';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    projectType,
    systemPowerSingleOrMultipleUsers,
    systemPowerOfftakerUtilityRateDiscount,
    systemPowerCommunityOrPPALease,
  },
} = loanFormModel;

export class OfftakerUtilityRateDiscountValidation implements ValidationSchema {
  public name: string = systemPowerOfftakerUtilityRateDiscount.name;
  public label: string = systemPowerOfftakerUtilityRateDiscount.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [
    projectType.name,
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(
    projectType: string,
    singleOrMultipleUsers: string,
    communityOrPPALease: string,
    schema
  ) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return schema;
    if (
      singleOrMultipleUsers === 'Single User' ||
      (singleOrMultipleUsers === 'Multiple Users' &&
        communityOrPPALease === 'PPA/Lease Agreement')
    ) {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new OfftakerUtilityRateDiscountValidation());
